module.exports = __webpack_public_path__ + "img/ripple.00f891fb.png";